var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M13.906,126.318A9.764,9.764,0,0,0,7,123.107a9.768,9.768,0,0,0-6.907,3.211.38.38,0,0,0,0,.5A9.756,9.756,0,0,0,7,130.029a9.773,9.773,0,0,0,6.907-3.211A.38.38,0,0,0,13.906,126.318Zm-4.11.25A2.741,2.741,0,0,1,7,129.242a2.677,2.677,0,1,1,0-5.348A2.741,2.741,0,0,1,9.8,126.568Zm-8.829,0a9.95,9.95,0,0,1,3.15-2.092,3.332,3.332,0,0,0,0,4.183,9.783,9.783,0,0,1-3.149-2.091Zm8.914,2.092a3.332,3.332,0,0,0,0-4.183,9.785,9.785,0,0,1,3.149,2.091A9.95,9.95,0,0,1,9.882,128.66Z",
    transform: "translate(0 -119.568)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M204,205.466A1.466,1.466,0,1,0,205.466,204,1.468,1.468,0,0,0,204,205.466Zm2.07,0a.6.6,0,1,1-.6-.6A.6.6,0,0,1,206.07,205.466Z",
    transform: "translate(-198.467 -198.466)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M240.431,1.869a.431.431,0,0,0,.431-.431V.431a.431.431,0,1,0-.862,0V1.437A.431.431,0,0,0,240.431,1.869Z",
    transform: "translate(-233.432)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M337.147,23.841a.431.431,0,0,0,.588-.161l.574-1.006a.431.431,0,1,0-.749-.427l-.574,1.006A.431.431,0,0,0,337.147,23.841Z",
    transform: "translate(-327.728 -21.396)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M123.735,23.68a.431.431,0,1,0,.749-.427l-.574-1.006a.431.431,0,1,0-.749.427Z",
    transform: "translate(-119.743 -21.396)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M240.431,445a.431.431,0,0,0-.431.431v1.006a.431.431,0,1,0,.862,0v-1.006A.431.431,0,0,0,240.431,445Z",
    transform: "translate(-233.432 -432.868)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M124.323,423.023a.431.431,0,0,0-.588.161l-.574,1.006a.431.431,0,0,0,.749.427l.574-1.006A.431.431,0,0,0,124.323,423.023Z",
    transform: "translate(-119.743 -411.469)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M337.735,423.184a.431.431,0,1,0-.749.427l.574,1.006a.431.431,0,1,0,.749-.427Z",
    transform: "translate(-327.728 -411.468)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.60688309a8e68ecf326d994e713bdc1d.svg";
export { ForwardRef as ReactComponent };